import { RotateCw } from 'lucide-react'

import { IconActionButton, IconActionButtonProps } from '../icon-action-button'

const Component = (props: IconActionButtonProps) => (
  <IconActionButton
    icon={RotateCw}
    tooltip="Atualizar"
    variant="outline"
    {...props}
  />
)

export default Component
